import { Injectable } from "@angular/core";
import { UseCase } from "../../base";
import { Observable } from "rxjs";
import { CreatePlanRulesTemplateRequest } from "../../domain";
import { PlanRulesTemplateRepository } from "../../repositories/plan-rules-template.repository";
@Injectable({ providedIn: 'root' })
export class CreatePlanRulesTemplateUsecase implements UseCase<CreatePlanRulesTemplateRequest, string> {
  constructor(private readonly planRulesTemplateRepository: PlanRulesTemplateRepository) {
  }

  execute(params: CreatePlanRulesTemplateRequest): Observable<string> {
    return this.planRulesTemplateRepository.CreatePlanRulesTemplate(params);
  }
}
